import {
  CloudIcon,
  CompassToolIcon,
  CurrencyDollarIcon,
  KeyholeIcon,
  KeyIcon,
  SparkleIcon,
  UserCircleGearIcon,
  UsersThreeIcon,
} from "@stacklet/ui";

import { SETTINGS_BREADCRUMB } from "app/constants/breadcrumbs";
import { paths } from "app/constants/paths";
import { useConfig } from "app/contexts/ConfigContext";
import { useHasScopePermission } from "app/hooks";

export function useSettingsBreadcrumbs() {
  const config = useConfig();
  const hasPermission = useHasScopePermission();
  const isAdmin = hasPermission("system", "EDIT");

  const adminTabs = isAdmin
    ? [
        {
          label: "Jun0",
          id: "settings-jun0",
          target: paths.settingsJun0,
          section: "AI",
          icon: SparkleIcon,
        },
        {
          label: "Identity Providers",
          id: "settings-identity-providers",
          target: paths.identityProviders,
          section: "Users & Groups",
          icon: KeyIcon,
        },
        {
          label: "Users",
          id: "settings-users",
          target: paths.users,
          section: "Users & Groups",
          icon: UserCircleGearIcon,
        },
        {
          label: "Groups",
          id: "settings-groups",
          target: paths.groups,
          section: "Users & Groups",
          icon: UsersThreeIcon,
        },
        ...(config?.dev_flags.includes("admin-settings")
          ? [
              {
                label: "Access Model",
                target: paths.accessModel,
                section: "Clouds & Integrations",
                icon: KeyholeIcon,
              },
            ]
          : []),
        {
          label: "Clouds",
          target: paths.settingsClouds,
          section: "Clouds & Integrations",
          icon: CloudIcon,
        },
        {
          label: "Cost",
          target: paths.settingsCost,
          section: "Clouds & Integrations",
          icon: CurrencyDollarIcon,
        },
        {
          label: "Integrations",
          target: paths.settingsIntegrations,
          section: "Clouds & Integrations",
          icon: CompassToolIcon,
        },
      ]
    : [];

  return [SETTINGS_BREADCRUMB, { tabs: adminTabs }];
}
